import React from 'react'
import { createSvgIcon } from '../createSvgIcon'

export const Fire = createSvgIcon(
  <path d="M6.37318 2.53511C6.36235 3.2424 6.12706 4.20005 5.024 4.57134C5.36941 3.7497 5.42212 2.96335 5.17741 2.22829C4.85035 1.24146 3.75906 0.470639 3.03294 0.0508747C2.78494 -0.0931252 2.46682 0.0856982 2.47153 0.372286C2.48094 0.895581 2.32188 1.66029 1.54965 2.43252C0.520941 3.46029 0 4.5224 0 5.58876C0 6.92758 0.941176 8.63958 2.82353 8.63958C0.921882 6.73793 2.35294 5.11817 2.35294 5.11817C2.75106 7.90123 4.70024 8.63958 5.64706 8.63958C6.45224 8.63958 8 8.05134 8 5.60523C8 4.13087 7.37318 3.01182 6.87765 2.35864C6.71435 2.14311 6.37694 2.26546 6.37318 2.53511Z" />,
  'Fire',
  { viewBox: '0 0 8 9' }
)
